import { useStaticData } from '@mc/static-data-react'
import { TrackingContainer } from '@mc/visibility'

import { Course } from '@mc/api'
import { type OutcomeKeyLearnings } from 'libs/server/api/outcomes'

import { OutcomeTilesDesktop } from './Desktop'
import { OutcomeTilesMobile } from './Mobile'
import { trackOutcomeTilesViewed } from '../../events'

interface OutcomeTilesProps {
  control: React.ReactNode
}

export const OutcomeTiles = ({ control }: OutcomeTilesProps) => {
  const { outcomesKeyLearnings, course } = useStaticData<{
    outcomesKeyLearnings: OutcomeKeyLearnings[]
    course: Course
  }>()
  if (!outcomesKeyLearnings) return control

  return (
    <section className='container mc-mt-10'>
      <TrackingContainer
        config={{ threshold: 0.3 }}
        onFirstVisible={() =>
          trackOutcomeTilesViewed({
            courseSlug: course.slug,
            outcomeTitles: outcomesKeyLearnings.map((outcome) => outcome.title),
          })
        }
      >
        {/* mobile */}
        <div className='d-block d-sm-none'>
          <OutcomeTilesMobile outcomesKeyLearnings={outcomesKeyLearnings} />
        </div>

        {/* desktop */}
        <div className='d-none d-sm-block'>
          <OutcomeTilesDesktop outcomesKeyLearnings={outcomesKeyLearnings} />
        </div>
      </TrackingContainer>
    </section>
  )
}
